const numeral = require('numeral')
const Chartist = require('chartist')
require('chartist-plugin-axistitle')

const GraduatesPieFrom17and18 = require('../data/GraduatesPieFrom17and18')
const StudentsEnrolledInBechelorDegreeChart = require('../data/StudentsEnrolledInBechelorDegreeChart')

const locale = window.location.pathname.split('/').includes('zh') ? 'zh' : 'en'

module.exports = {
  initGraduatesPieFrom17and18PieChart: () => {
    const elems = document.querySelectorAll('.pie-chart')

    if (elems.length <= 0) {
      return
    }

    const data = {
      labels: GraduatesPieFrom17and18.labels[locale],
      series: GraduatesPieFrom17and18.series,
    }
    const sumSeries = data.series.reduce((carry, cur) => carry + cur, 0)

    const options = {
      labelOffset: 80,
      chartPadding: 120,
      labelDirection: 'explode',
      labelInterpolationFnc: function(value, index) {
        return value + '~' + Math.round(data.series[index] / sumSeries * 100) + '%'
      }
    }

    const responsiveOptions = [
      ['screen and (max-width: 640px)', {
        options,
        chartPadding: 110,
        labelOffset: 70,
      }],
      ['screen and (min-width: 641px) and (max-width: 830px)', {
        labelOffset: 60,
        chartPadding: 130
      }],
      ['screen and (min-width: 831px) and (max-width: 1095px)', {
        labelOffset: 100,
        chartPadding: 50
      }],
      ['screen and (min-width: 1096px)', {
        labelOffset: 120,
        chartPadding: 20
      }]
    ]

    for (let i=0; i < elems.length; i++) {
      new Chartist.Pie(elems[i], data, options, responsiveOptions)
    }
  },

  initStudentsEnrolledInBechelorDegreeBarChart: () => {
    const elems = document.querySelectorAll('.bar-chart')

    if (elems.length <= 0) {
      return
    }

    const ChartistBarLabels = (Chartist) => {
      var defaultOptions = {
        // The class name so you can style the text
        labelClass: 'ct-bar-label',

        // Use this to get the text of the data and you can return your own
        // formatted text. For example, for a percentage:
        // {
        //  labelInterpolationFnc: function (text) { return text + '%' }
        // }
        labelInterpolationFnc: Chartist.noop,

        // Depending on your font size you may need to tweak these
        labelOffset: {
          x: 0,
          y: 0
        },

        // If labelOffset doesn't work for you and you need more custom positioning
        // you can use this. You can set position.x and position.y to functions and
        // instead of centering + labelOffset. This will _completely_ override the
        // built in positioning so labelOffset will no longer do anything. It will
        // pass the bar `data` back as the first param.
        //
        // Example:
        // Chartist.plugins.ctBarLabels({
        //   position: {
        //     x: function (data) {
        //       return data.x1 + 50; // align left with 50px of padding
        //     }
        //   }
        // });
        position: {
          x: null,
          y: null
        }
      };

      Chartist.plugins = Chartist.plugins || {};
      Chartist.plugins.ctBarLabels = function(options) {

        options = Chartist.extend({}, defaultOptions, options);

        var positionX = options.position.x || function (data) {
          return ((data.x1 + data.x2) / 2) + options.labelOffset.x;
        };

        var positionY = options.position.y || function (data) {
          return data.y2 - 10;
        };

        return function ctBarLabels(chart) {
          // Since it's specific to bars, verify its a bar chart
          if(chart instanceof Chartist.Bar) {
            chart.on('draw', function(data) {
              // If the data we're drawing is the actual bar, let's add the text
              // inside of it
              if(data.type === 'bar') {
                data.group.elem('text', {
                  // This gets the middle point of the bars and then adds the
                  // optional offset to them
                  x: positionX(data),
                  y: positionY(data),
                  style: 'text-anchor: middle'
                }, options.labelClass)
                .text(
                  numeral(options.labelInterpolationFnc(
                    // If there's not x (horizontal bars) there must be a y
                    data.value.x || data.value.y
                  ), true).format('0,0')
                );
              }
            });
          }
        };
      };
    }

    ChartistBarLabels(Chartist)

    for (let i=0; i<elems.length; i++) {
      new Chartist.Bar(elems[i], {
        labels: StudentsEnrolledInBechelorDegreeChart.labels,
        series: StudentsEnrolledInBechelorDegreeChart.series,
      }, {
        showArea: true,
        fullWidth: true,
        chartPadding: {
          top: 25,
          bottom: 50,
          left: 75,
          right: 50,
        },
        low: 0,
        axisY: {
          onlyInteger: true
        },
        plugins: [
          Chartist.plugins.ctAxisTitle({
            axisX: {
              axisTitle: StudentsEnrolledInBechelorDegreeChart.axisXTitle[locale],
              axisClass: `ct-axis-title`,
              offset: {
                x: 0,
                y: 50
              },
              textAnchor: 'middle'
            },
            axisY: {
              axisTitle: StudentsEnrolledInBechelorDegreeChart.axisYTitle[locale],
              axisClass: `ct-axis-title`,
              offset: {
                x: 0,
                y: 50,
              },
              textAnchor: 'middle',
              flipTitle: true
            }
          }),
          Chartist.plugins.ctBarLabels(),
        ]
      }).on('draw', function(data) {
        if (data.type === 'bar') {
          data.element.attr({
            style: 'stroke-width: 30px'
          });
        }
      })
    }
  }
}
